const WORKER_BASE_URL =
  'https://coolturystki-vakanza-api.krzysiek0212.workers.dev'

const REQUEST_TIMEOUT_MS = 8000

export async function getTripsByIds(tripIds) {
  const validIds = [
    ...new Set(
      tripIds
        .map(Number)
        .filter(id => Number.isInteger(id) && id > 0)
    ),
  ]

  if (validIds.length === 0) {
    return {
      data: [],
      missing: [],
      errors: [],
    }
  }

  const controller = new AbortController()

  const timeoutId = setTimeout(() => {
    controller.abort()
  }, REQUEST_TIMEOUT_MS)

  let response

  try {
    response = await fetch(
      `${WORKER_BASE_URL}/trips?ids=${validIds.join(',')}`,
      {
        signal: controller.signal,
      }
    )
  } catch (error) {
    if (error.name === 'AbortError') {
      throw new Error(
        'Przekroczono czas oczekiwania na dane terminów.'
      )
    }

    throw new Error(
      'Nie udało się połączyć z systemem rezerwacyjnym.'
    )
  } finally {
    clearTimeout(timeoutId)
  }

  let payload

  try {
    payload = await response.json()
  } catch {
    throw new Error(
      'System rezerwacyjny zwrócił nieprawidłową odpowiedź.'
    )
  }

  if (!response.ok) {
    throw new Error(
      payload?.error ??
        `Nie udało się pobrać terminów. Status: ${response.status}`
    )
  }

  return {
    data: Array.isArray(payload.data)
      ? payload.data
      : [],

    missing: Array.isArray(payload.missing)
      ? payload.missing
      : [],

    errors: Array.isArray(payload.errors)
      ? payload.errors
      : [],
  }
}